export default {"src":"/_next/static/media/car_overview_icon_blue.bec6ca3b.svg","height":14,"width":20};